<template>
<svg xmlns="http://www.w3.org/2000/svg" width="29.937" height="29.937" viewBox="0 0 29.937 29.937">
<g id="Group_2597" data-name="Group 2597" transform="translate(3 3)">
<path id="Path_1716" data-name="Path 1716" d="M7126.046,1389.315v23.937" transform="translate(-7114.077 -1389.315)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="6"/>
<path id="Path_1717" data-name="Path 1717" d="M0,0V23.937" transform="translate(0 11.969) rotate(-90)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="6"/>
</g>
</svg>
</template>